import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {faCheckSquare} from '@fortawesome/free-solid-svg-icons'
import {faSquare} from '@fortawesome/free-regular-svg-icons'

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css']
})
export class CheckBoxComponent implements OnInit {
  faSquare = faSquare;
  faCheckSquare = faCheckSquare;

  @Input() checked = false;
  @Output() checkedChange = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit() {
  }

  handleCheckClick(){
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked)
  }

}
